import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent, CardHeader } from '@/components/ui/card';
import { Button } from '@/components/ui/button';

interface ClassCardProps {
  classData: {
    id: string;
    name: string;
    is_active: boolean;
    is_event?: boolean;
    location_id?: string;
  };
  parentCanSelfEnrollTrial?: boolean;
}

const ClassCard: React.FC<ClassCardProps> = ({ classData, parentCanSelfEnrollTrial }) => {
  return (
    <Card className="flex flex-col h-full shadow-lg border-2 border-muted/60 hover:border-primary transition-all">
      <CardHeader className="pb-2 flex flex-row items-center gap-2 justify-between">
        <span className="font-semibold text-lg truncate" title={classData.name}>{classData.name}</span>
        <div className="flex gap-1">
          {classData.is_active ? (
            <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-green-100 text-green-700 text-xs font-semibold">Active</span>
          ) : (
            <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-gray-100 text-gray-500 text-xs font-semibold">Inactive</span>
          )}
          {classData.is_event ? (
            <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-purple-100 text-purple-700 text-xs font-semibold">Event</span>
          ) : (
            <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-blue-100 text-blue-700 text-xs font-semibold">Class</span>
          )}
        </div>
      </CardHeader>
      <CardContent className="flex-1 flex flex-col gap-2 justify-between">
        <div className="text-sm text-muted-foreground mb-2">
          <span className="font-medium">Location:</span> {classData.locations?.name || classData.location || '-'}
        </div>
        <div className="mt-auto flex gap-2">
          <Link to={`/admin/classes?classId=${classData.id}`} className="w-full">
            <Button variant="outline" className="w-full">View</Button>
          </Link>
        </div>
      </CardContent>
    </Card>
  );
};

export default ClassCard; 